
<template>

	<mymodal ref="modal" title="Группировка значений фактора" ok="Сохранить" :reset="reset" :check="check" :submit="submit" width="1000px">

		<b-row class="mt-2" align-v="center">

			<b-col cols="6" align="right">Значение фактора</b-col>
			<b-col class="info">{{ attr_reference.value }}</b-col>

		</b-row>

		<b-row class="mt-2" align-v="center">

			<b-col><h4>Группируемые факторы</h4></b-col>
			<b-col cols="2" align="right"><b-button size="sm" variant="outline-primary" class="filter-button" v-on:click="add_value"><b-icon-plus/></b-button></b-col>

		</b-row>

		<b-row v-for="( desc, ind ) in showed_values" :key="ind" align-v="center" class="mt-2">

			<b-col cols="4">
				<v-select v-if="desc.value == null" :clearable="false" v-model="desc.value" :options="values_able_for_choose" :reduce="obj => obj.value" :getOptionLabel="get_value_label" clearSearchOnSelect required appendToBody appendToParent v-on:input="value_changed"/>
				<div v-else>{{ desc.value }}</div>
			</b-col>
			<b-col cols="4"><b-form-input v-model="default_value" v-on:input="default_changed"/></b-col>
			<b-col cols="4"><v-select :clearable="false" v-model="code" :options="codes" taggable clearSearchOnSelect required appendToBody appendToParent :createOption="create_code" v-on:option:selecting="code_changed"/></b-col>

		</b-row>

	</mymodal>

</template>

<script>

import api from "../../../../../../../api"
import mymodal from "../../../../../../widgets/modal"

export default
{
	props :
	{
		cost_evaluation_id : String,
		data : Object,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {

			attr : null,
			attr_reference : {},
			showed_values : [],
			values : [],
			values_able_for_choose : [],
			default_value : null,
			default_value_not_edit : true,
			code : null,
			codes : [],

		}
	},

	methods :
	{
		check()
		{
			return this.showed_values.every(desc => desc.value != null && desc.value != "") && this.default_value != null && this.default_value != "" && this.code != null && this.code != ""
		},

		reset()
		{
		},

		execute(attr, attr_reference, raw_values = null)
		{
			this.attr = attr
			this.attr_reference = attr_reference
			this.default_value = attr_reference.default
			this.code = attr_reference.code
			this.showed_values = []
			this.values = []

			if(raw_values == null)
				this.values = [ { label : "Да", value : "true" }, { label : "Нет", value : "false" } ]
			else
				this.values = raw_values.map(val => new Object({ label : api.format_attr_value(attr, val), value : val }))

			const showed_values_raw = this.refresh()

			this.default_value_not_edit = this.default_value == showed_values_raw.join(";")
			this.refresh_values_able_for_choose()

			this.$refs.modal.execute()
		},

		refresh(code = null)
		{
			if(code == null)
				code = this.code

			var showed_values_raw = []
			var codes = new Set()

			Object.entries(this.attr.attr_reference).forEach(
				elem =>
				{
					const value = elem[0]
					const desc = elem[1]

					if(desc.code == code)
					{
						if(this.showed_values.findIndex(elem => elem.value == value) < 0)
							this.showed_values.push({ value : value })

						showed_values_raw.push(value)
					}

					codes.add(desc.code)
				})

			this.codes = Array.from(codes)

			return showed_values_raw
		},

		refresh_values_able_for_choose()
		{
			this.values_able_for_choose = this.values.filter(value => this.showed_values.findIndex(_value => _value.value == value.value) < 0)
		},

		submit()
		{
			var fields = {}

			this.showed_values.forEach(
				desc =>
				{
					const value = desc.value
					const code = this.code
					const key_default = `modeling.attrs_references.${this.attr.id}.values.${value}.default`
					const key_code = `modeling.attrs_references.${this.attr.id}.values.${value}.code`

					this.attr.attr_reference[value].default = this.default_value
					this.attr.attr_reference[value].code = code
					fields[key_default] = this.default_value
					fields[key_code] = code
				})

			this.$emit("need_refresh")
			this.$emit("edit", { fields : fields, save_operation_in_history : true })
		},

		add_value()
		{
			this.showed_values.push({ value : null })
		},

		get_value_label(option)
		{
			if(option.label)
				return option.label
			
			return api.format_attr_value(this.attr, option)
		},

		value_changed()
		{
			if(this.default_value_not_edit)
			{
				var fields = []

				this.showed_values.forEach(desc => fields.push(api.format_attr_value(this.attr, desc.value)))
				this.default_value = fields.join(";")
				this.refresh_values_able_for_choose()
			}
		},

		default_changed()
		{
			this.default_value_not_edit = false
		},

		create_code(code)
		{
			const code_number = Number(code)

			if(! isNaN(code_number) && code_number >= 0 && this.codes.findIndex(code => code == code_number) < 0 )
			{
				this.$emit("option:created", code)

				return code
			}

			return this.code
		},

		code_changed(code)
		{
			if(this.code != code)
			{
				this.refresh(code)

				this.default_value = Object.values(this.showed_values).map(elem => api.format_attr_value(this.attr, elem.value)).join(";")
			}
		},
	}
}

</script>

